import { ContactList, ContactVM } from '../back-office-admin-common/contact.models';
import { LocationFullDTO } from '../../../../shared/models/location.model';
import { ICompanyForm } from '../back-office-admin-common/customer-check-in.model';
import { AgencyDto } from 'app/shared/models/agency.model';
import { CustomerCategoryDTO } from 'app/shared/models/customer-category.model';



export class AgencyListItemVM extends AgencyDto {
  locationCity: string;
  checked?: boolean;
  declare fullName: string;
  nameWhitCode?: string;
  code: string;
  agencyStoreId: number;
  constructor(init?: Partial<AgencyListItemVM>) {
    super();
    Object.assign(this, init);
    if (!this.locationCity && this.location?.city) this.locationCity = this.location.city;
  }
}

export class AgencyVM extends AgencyDto {
  agencyCategories: CustomerCategoryDTO[];
  agencyCategoriesSelected: CustomerCategoryDTO[];
  agencyForms: ICompanyForm[];
  contactList: ContactVM[];
  constructor(init?: Partial<AgencyVM>) {
    super();
    Object.assign(this, init);
  }
}




export class RegisterAgencyVM {
  agency: AgencyRegisterDto;
  location: LocationFullDTO;
  contacts: ContactVM[];
  constructor(init?: Partial<RegisterAgencyVM>) {
    Object.assign(this, init);
  }
}

export class AgencyRegisterDto {
  name: string;
  fiscalCode: string;
  vatNumber: string;
  checkInStatus: number;
  code?: string;
  externalId: string;
  locationId: number;
  companyFormId: number;
}
